import sanitizeHtml from "sanitize-html";

export const DESCRIPTION_MAX_LENGTH = 2000;

const allowedTags = [
  "p",
  "br",
  "ul",
  "ol",
  "li",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "s",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "a",
];

export const stripHtml = (value: string): string =>
  value.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();

export const sanitizeDescriptionHtml = (value: string): string =>
  sanitizeHtml(value || "", {
    allowedTags,
    allowedAttributes: { a: ["href", "target", "rel"] },
    allowedSchemes: ["http", "https", "mailto", "tel"],
    transformTags: {
      a: sanitizeHtml.simpleTransform("a", {
        target: "_blank",
        rel: "noopener noreferrer",
      }),
    },
  }).trim();

export const hasVisibleDescriptionContent = (value: string): boolean =>
  stripHtml(sanitizeDescriptionHtml(value)).length > 0;

export const toDescriptionDisplayHtml = (value: string): string => {
  if (!value) return "";

  const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(value);
  if (!hasHtmlTags) {
    const safeText = sanitizeHtml(value, { allowedTags: [], allowedAttributes: {} });
    return safeText.replace(/\r\n|\r|\n/g, "<br />").trim();
  }

  return sanitizeDescriptionHtml(value);
};
